import { advisorSettlementApi } from './advisor-settlement.api';

export const advisorSettlementActions = {
  async getAdvisorSettlements({ commit }, payload) {
    try {
      commit('GET_ADVISOR_SETTLEMENTS_LOADING');
      const response = await advisorSettlementApi.getAdvisorSettlements(payload);
      commit('GET_ADVISOR_SETTLEMENTS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_ADVISOR_SETTLEMENTS_ERROR', error.response);
    }
  },
  async getAdvisorSettlement({ commit }, id) {
    try {
      commit('GET_ADVISOR_SETTLEMENT_LOADING');
      const response = await advisorSettlementApi.getAdvisorSettlement(id);
      commit('GET_ADVISOR_SETTLEMENT_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_ADVISOR_SETTLEMENT_ERROR', error.response);
    }
  },
  async updateAdvisorSettlement({ commit }, { id, body }) {
    try {
      commit('UPDATE_ADVISOR_SETTLEMENT_LOADING');
      const response = await advisorSettlementApi.updateAdvisorSettlement(id, body);
      commit('UPDATE_ADVISOR_SETTLEMENT_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_ADVISOR_SETTLEMENT_ERROR', error.response);
    }
  },
};
